import { render, staticRenderFns } from "./overlayLoader.vue?vue&type=template&id=192c2847&scoped=true&"
import script from "./overlayLoader.vue?vue&type=script&lang=js&"
export * from "./overlayLoader.vue?vue&type=script&lang=js&"
import style0 from "./overlayLoader.vue?vue&type=style&index=0&id=192c2847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c2847",
  null
  
)

export default component.exports